import React from "react";
import banner from "../../assets/12_Quienes somos/Sobre nosotros/sobre-nosotros-banner-hb20-vista-lateral-trasera-banner.webp";

/*eslint-disable */

declare const window: any;
const BannerComponent: React.FC = () => {
  return (
    <div
      className="banner-quienes-somos-component"
      style={{ position: "relative", overflow: "hidden" }}
    >
      <img
        src={banner}
        alt="Saber elegir, es Hyundai"
        {...({ fetchpriority: "high" } as any)}
        loading="eager"
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          objectFit: "cover",
          zIndex: 0,
          pointerEvents: "none"
        }}
      />
      {/* H1 - Título principal de la página */}
      <h1 className="mascara-banner-quienes-somos-component" style={{ position: "relative", zIndex: 1 }}>
        Saber elegir, es Hyundai
      </h1>
    </div>
  );
};

export default BannerComponent;